import BetsCycleLoader from 'src/core/components/betscycle-loader'

const SpinnerComponent = () => {
	return (
		<div className='fallback-spinner vh-100 d-flex align-items-center justify-content-center'>
			<BetsCycleLoader size={64} />
		</div>
	)
}

export default SpinnerComponent
